import { Component, Input } from "@angular/core";

@Component({
  selector: "app-menu-item",
  templateUrl: "./app-menu-item.component.html",
  styleUrls: ["./app-menu-item.component.scss"]
})
export class AppMenuItemComponent {
  @Input()
  title: string;
  @Input()
  linkTo: string;
  constructor() {}

}
